import type { IGroupedControlOption } from '@/Interfaces/ControlOption.interface';
import type { GetOptionDisabled } from '@/types/Controls/TabSelect.types';
import { Checkbox, ListItemText, MenuItem, Typography } from '@mui/material';
import { Fragment, useMemo } from 'react';

interface IProps {
  options: IGroupedControlOption[];
  value?: IGroupedControlOption[];
  onChange: (value: IGroupedControlOption, checked: boolean) => void;
  getOptionDisabled?: GetOptionDisabled<IGroupedControlOption>;
}

const GroupOptionsRenderer = ({ options, value, onChange, getOptionDisabled }: IProps) => {
  const displayedGroups = new Set();
  const selectedOptionValues = useMemo(() => {
    return new Set((value ?? []).map(({ value }) => value));
  }, [value]);

  return options.map(option => {
    const showGroupLabel = !displayedGroups.has(option.groupLabel);
    displayedGroups.add(option.groupLabel);

    const checked = selectedOptionValues.has(option.value);
    const disabled = getOptionDisabled?.(option, value ?? [], checked);

    return (
      <Fragment key={`${option.label}_${option.value}`}>
        {showGroupLabel ? <div className='font-bold text-[18px] my-[8px] ml-[12px]'>{option.groupLabel}</div> : null}
        <MenuItem
          value={option.value}
          selected={checked}
          onClick={() => onChange(option, !checked)}
          disabled={disabled}
        >
          <Checkbox checked={checked} disabled={disabled} />
          <ListItemText>
            <Typography variant='inherit' noWrap>
              {option.label}
            </Typography>
          </ListItemText>
        </MenuItem>
      </Fragment>
    );
  });
};

export default GroupOptionsRenderer;
